<template>
  <div class="productDetails">
    <div class="boxCenter">
      <div class="insideBanner">
        <img :src="bannerImg" alt="TINDOE坦途"/>
      </div>
      <div class="infoBox">
          <div class="title">{{dataObj.title}}</div>
          <div class="times">发布时间：{{dataObj.createDate?dataObj.createDate.substring(0,19):''}}</div>
          <div class="des">{{dataObj.digest}}</div>
          <div class="imgBox"><img :src="dataObj.pic" alt="TINDOE坦途"/></div>
          <div class="ql-container ql-snow">
              <div class="ql-editor">
                <div class="content" v-html="dataObj.content">
                  <!-- {{dataObj.content}} -->
                </div>
              </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data(){
      return {
        newId:'',
        dataObj:{},
        bannerImg:''
      }
    },
    mounted(){
      this.newId = this.$route.params.id
      this.loadData()
      this.loadBanner()
      //eventVue.$emit("navSwitch",'news')
    },
    methods:{
      loadBanner(){
        this.$https.get('/api/config').then((response)=>{
          //this.dataObj = response.data
          for(let i=0;i<response.data.length;i++){
            let item = response.data[i]
            if(item.id == 10){
              this.bannerImg = item.msg
              break
            }
          }
        })
      },
      loadData(){
        this.$https.get('/api/news/id/'+this.newId).then((response)=>{
          this.dataObj = response.data
        }).catch((error) => {});
      }
    }
  }
</script>

<style scoped>
  .ql-container.ql-snow{
    border:0px;
  }
  .insideBanner{
    width: 1200px;
    height: 275px;
    position: relative;
  }
  .infoBox{
    padding: 40px 140px;
  }
  .infoBox .title{
    text-align: center;
    line-height: 54px;
    font-size: 28px;
    color: #5680f9;
  }
  .infoBox .times{
    line-height: 35px;
    font-size: 12px;
    color: #969696;
    text-align: center;
  }
  .infoBox .des{
    margin: 20px 0px;
    background: #f0f0f0;
    font-size: 14px;
    color: #7b7b7b;
    padding: 10px;
  }
  .infoBox .content{
    padding-top: 20px;
  }
  .infoBox .imgBox{
    width: 570px;
    margin: 0 auto;
  }
  .infoBox .imgBox img{
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/newsDetails.vue